import React from "react";

import { Avatar, Box, Typography } from "@mui/material";
import { format } from "date-fns";
import { withStyles } from "tss-react/mui";

import { graphql } from "@/gql";
import { FragmentType } from "@/utils/type";

const Container = withStyles(Box, {
  root: {
    alignItems: "center",
    display: "flex",
    marginBlock: "20px",
    padding: "8px",
  },
});

const ClientAvatar = withStyles(Avatar, {
  root: {
    border: "2px solid #26C9A7",
    marginRight: "10px",
  },
});

const ClientNameText = withStyles(Typography, {
  root: {
    color: "#26C9A7",
    fontSize: 16,
    fontWeight: 400,
  },
});

const ClientProgramText = withStyles(Typography, {
  root: {
    color: "#4C515A",
    fontSize: 14,
    fontWeight: 600,
  },
});

const NotificationDateText = withStyles(Typography, {
  root: {
    color: "#4C515A",
    fontSize: 14,
    fontWeight: 600,
    width: "20%",
  },
});

const NotificationMessageText = withStyles(Typography, {
  root: {
    color: "#4C515A",
    fontSize: 14,
    fontWeight: 600,
  },
});

const notificationTileFragment = graphql(`
  fragment NotificationDetails on Notification {
    id
    notifier {
      ... on Client {
        id
        profile {
          id
          avatarUrl
          fullName
        }
        programForDate(date: $date) {
          id
          name
        }
      }
    }
    message
    createdAt
  }
`);

interface NotificationTileProps {
  notification: FragmentType<typeof notificationTileFragment>;
}

const NotificationTile = React.forwardRef<
  HTMLDivElement,
  NotificationTileProps
>(({ notification }, ref) => {
  const client =
    notification.notifier.__typename === "Client"
      ? notification.notifier
      : undefined;

  return (
    <Container ref={ref}>
      <ClientAvatar
        src={client?.profile?.avatarUrl ?? undefined}
        alt={`${client?.profile?.fullName} photo`}
      >
        {client?.profile?.fullName.charAt(0)}
      </ClientAvatar>

      <Box width="22%">
        <ClientNameText>{client?.profile?.fullName}</ClientNameText>
        <ClientProgramText>{client?.programForDate?.name}</ClientProgramText>
      </Box>

      <NotificationDateText>
        {format(new Date(notification.createdAt), "MMMM dd, yyyy | hh:mm aaa")}
      </NotificationDateText>

      <NotificationMessageText>{notification.message}</NotificationMessageText>
    </Container>
  );
});

export default NotificationTile;
